import React from 'react';

const Earning = () => {
  return (
    <div className={'col-12 col-md-6 px-3 py-4'} style={{ minHeight: '100%' }}>
      <div className="earning-header-container">
        <p>Date</p>
        <p>Item</p>
        <p>Amount</p>
      </div>
      <div className="earning-container">
        <p>01.01.2020</p>
        <p>Purchase</p>
        <p>50.000$</p>
      </div>
      <div className="earning-container">
        <p>01.01.2020</p>
        <p>Purchase</p>
        <p>50.000$</p>
      </div>
      <div className="earning-container">
        <p>01.01.2020</p>
        <p>Purchase</p>
        <p>50.000$</p>
      </div>
      <div className="earning-container">
        <p>01.01.2020</p>
        <p>Purchase</p>
        <p>50.000$</p>
      </div>
    </div>
  );
};

export default Earning;
